export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72')
];

export const server_loads = [];

export const dictionary = {
		"/": [26],
		"/account": [31,[3]],
		"/account/verify-email": [32,[3]],
		"/admin": [33,[4]],
		"/admin/blacklist-hits": [51,[4,11]],
		"/admin/invites": [52,[4,12]],
		"/admin/settings": [53,[4,13]],
		"/admin/speakers": [54,[4,14]],
		"/admin/speakers/new": [57,[4,14]],
		"/admin/speakers/[speaker_tag]": [55,[4,14,15]],
		"/admin/speakers/[speaker_tag]/edit": [56,[4,14,15]],
		"/admin/stats": [58,[4,16]],
		"/admin/stats/[stream_tag]": [59,[4,16]],
		"/admin/streams": [60,[4,17]],
		"/admin/streams/new": [64,[4,17]],
		"/admin/streams/[stream_tag]": [61,[4,17,18]],
		"/admin/streams/[stream_tag]/edit": [62,[4,17,18]],
		"/admin/streams/[stream_tag]/refresh": [63,[4,17,18]],
		"/admin/[tag]": [34,[4,5]],
		"/admin/[tag]/moderation": [35,[4,5,6]],
		"/admin/[tag]/overlay": [36,[7]],
		"/admin/[tag]/panel": [37,[4,5,8]],
		"/admin/[tag]/settings": [38,[4,5,9]],
		"/admin/[tag]/settings/broadcast": [39,[4,5,9]],
		"/admin/[tag]/settings/goals": [40,[4,5,9]],
		"/admin/[tag]/settings/image-tips": [41,[4,5,9]],
		"/admin/[tag]/settings/overlay": [42,[4,5,9]],
		"/admin/[tag]/settings/overlay/[short_id]": [43,[4,5,9]],
		"/admin/[tag]/settings/payments": [44,[4,5,9]],
		"/admin/[tag]/settings/show": [45,[4,5,9]],
		"/admin/[tag]/settings/text-tips": [46,[4,5,9]],
		"/admin/[tag]/settings/voice-tips": [47,[4,5,9]],
		"/admin/[tag]/verify-email": [48,[4,5]],
		"/admin/[tag]/voices/new": [50,[4,5,10]],
		"/admin/[tag]/voices/[voice_tag]": [49,[4,5,10]],
		"/diagnostics": [65],
		"/leaderboard": [66,[19]],
		"/onboard": [68,[21]],
		"/o/[short_id]": [67,[20]],
		"/privacy": [69,[22]],
		"/signin": [70,[23]],
		"/submission": [71,[24]],
		"/terms": [72,[25]],
		"/[tag]": [27,[2]],
		"/[tag]/image": [28,[2]],
		"/[tag]/text": [29,[2]],
		"/[tag]/voice": [30,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';